import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //API_URL: 'https://localhost:7287',
    API_URL: 'https://server.fcbstudios.com',
    LOADING: [],
    ERRORS: []
  },
  mutations: {
    AddLoading(state, loading) {
      state.LOADING.push(loading)
    },
    RemoveLoading(state, loading) {
      let i = state.LOADING.indexOf(loading)
      if(i > -1) state.LOADING.splice(i, 1)
      else console.log('LOADING WARNING: ' + loading + ' was not found.')
    }
  }
})